'use client';

import { FC } from 'react';
import styles from './ExploreCardSkeleton.module.scss';
export interface ExploreCardSkeletonsProps {
  /** How many placeholder cards to render. */
  count: number;
}

/**
 * Placeholder cards for a results refresh that happens after the page has
 * loaded — searching again, switching type, applying filters. The route-level
 * `workspaces/loading.tsx` only covers the very first load; without these, a
 * search run from a zero-result page has no results to keep on screen and the
 * user stares at the empty state until the new ones land.
 *
 * Renders bare cards so the caller's own grid/list container controls layout.
 */
const ExploreCardSkeletons: FC<ExploreCardSkeletonsProps> = ({
  count
}) => <>
        {Array.from({
    length: count
  }).map((_, i) => <div key={i} className={styles.card} aria-hidden="true">
                <div className={`${styles.shimmer} ${styles.cardImage}`} />
                <span className={`${styles.shimmer} ${styles.lineTitle}`} />
                <span className={`${styles.shimmer} ${styles.lineCity}`} />
                <span className={`${styles.shimmer} ${styles.linePrice}`} />
            </div>)}
    </>;
export default ExploreCardSkeletons;